import { ButtonView, ButtonVariant } from "common/views/button/Button.view";

const ShareButton = (props) => {
    const {shareUrl, imgUrl, brand} = props;
    return (
    <ButtonView href={shareUrl} variant={ButtonVariant.PRIMARY} viewKey={`button.${brand}`}>
			<img src={imgUrl} alt={`Share on ${brand}`} />
		</ButtonView>
    )
}

export default ShareButton;


// WEBPACK FOOTER //
// ./src/common/fragments/ShareButton.tsx